<template>
  <!--
    Code By     : 陈伦刚
    CreateTime  : 2021-06-01 08:39:06
    Description : 素材 的卡片
  -->
  <div
    class="item"
    @click="$emit('click')"
    @mouseenter="mouseenter"
    @mouseleave="mouseleave"
  >
    <div class="discount-item" :style="{backgroundColor: data.material.displayPrice === 0 ? '#fe5d61' : '#fd9772'}" v-if='data.material.countdown !== 0'>
      <div class='text-header'>
        {{countDownTextHeader}}
      </div>
      <div class='text-body'>
        {{countDownTextBody}}
      </div>
    </div>
    <el-image
      class="cover"
      v-show="!showVideo"
      fit="cover"
      :src="cover"
    >
      <template #error>
        <div style='width: 100%; height: 100%; background-color: #f5f7fa;'>
           <div class="error">
             {{errorText}}
           </div>
        </div>
      </template>
    </el-image>
    <video
      ref="media"
      muted
      class="cover"
      v-show="showVideo"
      autoplay="autoplay"
      loop="loop"
    >
      <source class="cover" :src="videoCover" type="video/mp4" />
    </video>
    <div
      class="time"
      :style="{ visibility: showVideo || !isShowTime ? 'hidden' : 'visible' }"
    >
      {{ getTime() }}
    </div>
    <div class="info">
      <div class="name">{{ data.material.title }}</div>
      <div class="content">{{ getContent() || "无" }}</div>
      <div class="price" v-if="showPrice">
        <span class="free" v-if="!data.material.allowDownload">免费</span>
        <span class="free" v-else-if="data.material.displayPrice == -3">
          出售中
        </span>
        <span class="free" v-else-if="data.material.displayPrice == -2">
          已购买
        </span>
        <span v-else>
          <span
            class="first"
            v-if="data.material.firstPrice != data.material.displayPrice"
          >
            {{ (data.material.firstPrice / 100).toFixed(2) }}
          </span>
          <span class="display">
            ¥{{ (data.material.displayPrice / 100).toFixed(2) }}
          </span>
        </span>
      </div>
      <div class="pay" v-else>
        {{ data.material.allowDownload ? "付费" : "免费" }}
      </div>
    </div>
  </div>
</template>

<script>
import { timeConversion } from "@/utils/utils";
import dayjs from 'dayjs'
import { secondToDate } from '../../utils/utils'
export default {
  props: {
    data: {
      type: Object,
      default: {},
    },
    showPrice: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      showVideo: false,
      videoCover: "",
      cover: null,
      isShowTime: false,
      errorText: "加载失败",
      countDownTime: 0,
    };
  },
  watch: {
    data(new_value, old_value) {
      if (new_value != old_value) {
        setTimeout(() => {
          this.loadData();
        }, 100);
      }
    },
  },
  created() {
    this.loadData();
    this.countDown()
  },
  methods: {
    loadData() {
      const baseUrl = process.env.VUE_APP_RESOURCES_URL;
      const material = this.data.material;
      const contentType = this.data.contentType;
      if(contentType === "template" || contentType === "virtualProperty") {
        this.errorText = "封面更新中"
      }
      if (material.cover) {
        this.cover = baseUrl + material.cover;
      }
      if (material.video) {
        material.video.resources.map((el) => {
          if (el.resourceName === "180" && !material.cover) {
            this.cover = baseUrl + el.resourceKey;
          }
          if (contentType === "video" || contentType === "template" || contentType === "virtualProperty") {
            if (el.type === "COVER") {
              this.videoCover = baseUrl + el.resourceKey;
              setTimeout(() => {
                this.$refs.media.addEventListener(
                  "loadstart",
                  this.handleLoadstart
                );
                this.$refs.media.addEventListener("play", this.handlePlay);
                this.$refs.media.addEventListener("pause", this.handlePause);
              }, 0);
            }
          }
        });
      }
      this.isShowTime = ["video", "music"].includes(contentType);
      if(contentType === "virtualProperty" && material.video) {
        this.isShowTime = true
      }
    },
    handleLoadstart() {
      console.log("handleLoadstart");
    },
    handlePlay() {
      console.log("handlePlay");
    },
    handlePause() {
      console.log("handlePause");
    },
    mouseenter() {
      const type = this.data.contentType;
      if (["video", "template", "virtualProperty"].includes(type) && this.videoCover) {
        this.showVideo = true;
      }
    },
    mouseleave() {
      this.showVideo = false;
    },
    getContent() {
      const material = this.data.material;
      const contentType = this.data.contentType;
      if (contentType === "video") {
        if(material.video){
          const videoInfo = material.video.videoInfo;
          return `${videoInfo?.codecName} | ${videoInfo?.width}×${
            videoInfo?.height
          } | ${videoInfo?.fps.toFixed(2)}FPS`;
        }
      }
      if(contentType === "virtualProperty") {
        return "虚拟资产素材"
      }
      if (contentType === "picture") {
        const imageInfo = material.video.imageInfo;
        return `${imageInfo.format.toLocaleUpperCase()} | ${imageInfo.width}×${
          imageInfo.height
        }`;
      }
      if (contentType === "music") {
      }
      if (contentType === "template") {
        return `模板素材`;
      }
      if (contentType === "other") {
        return `其它素材`;
        const template = material.template;
        return `${template.format}`;
      }
    },
    getTime() {
      const material = this.data.material;
      const contentType = this.data.contentType;
      if (contentType === "video" || contentType === "virtualProperty") {
          return timeConversion(material.video?.videoInfo?.duration);
      } else if (contentType === "music") {
        return timeConversion(material.video.audioInfo.duration);
      }
    },
    countDown() {
      this.countDownTime = this.data.material.countdown
      setInterval(() => {
        this.countDownTime = this.countDownTime - 1000
      }, 1000)
    }
  },
  computed: {
    countDownTextHeader() {
      return this.data.material.displayPrice === 0 ? '限时免费' : '距折扣结束还剩'
    },
    countDownTextBody() {
      let PrefixInteger = (num, n = 2) => {
        return (Array(n).join('0') + num).slice(-n)
      }
      let formatDuring = (mss) => {
        let days = Math.floor(mss / (1000 * 60 * 60 * 24))
        let hours = Math.floor((mss % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60))
        let minutes = Math.floor((mss % (1000 * 60 * 60)) / (1000 * 60))
        let seconds = Math.floor(mss % (1000 * 60) / 1000)
        return days + '天 ' + PrefixInteger(hours) + ':' + PrefixInteger(minutes) + ':' + PrefixInteger(seconds)
      }
      return formatDuring(this.countDownTime)
    }
  }
};
</script>

<style lang="less" scoped>
.text-overflow() {
  overflow: hidden;
  white-space: nowrap;
  text-overflow: ellipsis;
}
.item {
  position: relative;
  display: inline-block;
  box-sizing: border-box;
  width: 24%;
  height: 220px;
  // box-shadow: 0 2px 12px 0 rgba(0, 0, 0, 0.1);
  cursor: pointer;
  transition: all 0.4s;
}

.item:hover {
  // box-shadow: 0 0.5rem 1rem rgba(0, 0, 0, 0.15);
  transition: all 0.4s;
}

.item:active {
  box-shadow: none;
  transition: all 0.2s;
}

.cover {
  width: 100%;
  height: 160px;
  object-fit: fill;
}

.info {
  margin-top: -23px;
  height: 88px;
  background: #ffffff;
  .name,
  .content,
  .pay {
    padding-left: 8px;
    font-size: 13px;
    font-weight: 700;
    color: #717171;
    .text-overflow();
  }
  .name {
    width: 95%;
    padding-top: 6px;
  }
  .content {
    margin: 12px 8px 0;
    padding-left: 0;
    padding-bottom: 8px;
    font-size: 12px;
    font-weight: 300;
    border-bottom: solid 1px #a7a7a7;
  }
  .pay {
    // margin: -20px 10px 10px 0;
    margin-top: 6px;
    font-size: 12px;
    text-align: right;
    padding-right: 20px;
  }
  .price {
    font-size: 12px;
    text-align: right;
    padding-top: 8px;
    .free,
    .first,
    .display {
      margin: 0 8px;
    }
    .display {
      font-weight: bold;
      color: #fd5f64;
    }
    .first {
      font-size: 10px;
      font-weight: 400;
      text-decoration: line-through;
      color: #999999;
    }
    .free {
      color: #4cc2ff;
      font-weight: bold;
    }
  }
}
.time {
  position: relative;
  top: -36px;
  left: 82%;
  width: 40px;
  height: 20px;
  line-height: 20px;
  font-size: 12px;
  border-radius: 4px;
  text-align: center;
  background: rgba(0, 0, 0, 0.4);
  color: #ffffff;
}

.error {
  width: 100%;
  height: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
  font-size: 14px;
  color: #c0c4cc;
  vertical-align: middle;
}

.discount-item  {
  position: absolute;
  top: 10px;
  right: 0;
  width: 100px;
  height: 42px;
  border-radius: 8px 0px 0px 8px;
  background-color: red;
  z-index: 999;
  display: flex;
  flex-direction: column;
  align-items: center;
}
.text-header {
  font-size: 10px;
  font-weight: 400;
  line-height: 24px;
  color: #ffffff;
}
.text-body {
  font-size: 12px;
  font-weight: bold;
  color: #ffffff;
}
</style>
